module.exports = __webpack_public_path__ + "static/media/7.a7d3c962.jpg";